import { render, staticRenderFns } from "./DialogHistoryPrice.vue?vue&type=template&id=25b236d0&scoped=true&"
import script from "./DialogHistoryPrice.vue?vue&type=script&lang=js&"
export * from "./DialogHistoryPrice.vue?vue&type=script&lang=js&"
import style0 from "./DialogHistoryPrice.vue?vue&type=style&index=0&id=25b236d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b236d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VProgressCircular,VRow})
